import { render, staticRenderFns } from "./TextEditor.vue?vue&type=template&id=77d638d4&scoped=true"
import script from "./TextEditor.vue?vue&type=script&lang=js"
export * from "./TextEditor.vue?vue&type=script&lang=js"
import style0 from "./TextEditor.vue?vue&type=style&index=0&id=77d638d4&prod&lang=sass"
import style1 from "./TextEditor.vue?vue&type=style&index=1&id=77d638d4&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d638d4",
  null
  
)

export default component.exports